module.exports = __webpack_public_path__ + "media/Hilfevideo_LBST_Sortieren.096a5e0a.mp4";